var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rootCategory)?_c('div',{staticClass:"categories px-3 py-2"},_vm._l((_vm.children),function(child){return _c('category-node',{key:child.id,attrs:{"category":child,"level":1}})}),1):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f74c145","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CategoryTree.vue
// module id = HNwC
// module chunks = 0